var _path, _path2, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgBookCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 61,
    viewBox: "0 0 57 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0501 43.595L32.0072 46.7989C41.9715 49.4689 47.0252 46.5511 49.6951 36.5868L52.8991 24.6297C55.569 14.6654 52.6512 9.61172 42.6869 6.9418L30.7298 3.73789C20.7655 1.06797 15.7118 3.98571 13.0419 13.95L9.83799 25.9071C7.16806 35.8714 10.0858 40.9251 20.0501 43.595Z",
    fill: "#6565EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0316 53.3315H29.4105C39.7263 53.3315 43.8526 49.2052 43.8526 38.8894V26.5105C43.8526 16.1947 39.7263 12.0684 29.4105 12.0684H17.0316C6.71579 12.0684 2.58948 16.1947 2.58948 26.5105V38.8894C2.58948 49.2052 6.71579 53.3315 17.0316 53.3315Z",
    fill: "#6565EE",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3234_25437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4421 53.8999H29.8211C40.1368 53.8999 44.2632 49.7736 44.2632 39.4578V27.0788C44.2632 16.763 40.1368 12.6367 29.8211 12.6367H17.4421C7.12632 12.6367 3 16.763 3 27.0788V39.4578C3 49.7736 7.12632 53.8999 17.4421 53.8999Z",
    fill: "url(#paint0_linear_3234_25437)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4421 53.8999H29.8211C40.1368 53.8999 44.2632 49.7736 44.2632 39.4578V27.0788C44.2632 16.763 40.1368 12.6367 29.8211 12.6367H17.4421C7.12632 12.6367 3 16.763 3 27.0788V39.4578C3 49.7736 7.12632 53.8999 17.4421 53.8999Z",
    stroke: "url(#paint1_linear_3234_25437)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3234_25437)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1154 28.6449C24.2036 28.1931 24.6412 27.8984 25.0929 27.9865C26.0697 28.1771 26.9673 28.6548 27.671 29.3585C28.3747 30.0621 28.8524 30.9598 29.0429 31.9365C29.1311 32.3882 28.8363 32.8259 28.3846 32.914C27.9329 33.0021 27.4952 32.7074 27.4071 32.2557C27.2801 31.6045 26.9616 31.0061 26.4925 30.537C26.0234 30.0679 25.4249 29.7494 24.7738 29.6223C24.322 29.5342 24.0273 29.0966 24.1154 28.6449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1051 25.3791C24.1559 24.9217 24.5679 24.592 25.0254 24.6429C26.9043 24.8516 28.6565 25.693 29.9941 27.029C31.3317 28.3649 32.1754 30.116 32.3865 31.9947C32.4379 32.4521 32.1088 32.8645 31.6514 32.9159C31.194 32.9673 30.7816 32.6382 30.7302 32.1808C30.5613 30.6779 29.8864 29.277 28.8163 28.2082C27.7462 27.1395 26.3445 26.4663 24.8413 26.2993C24.3839 26.2485 24.0543 25.8365 24.1051 25.3791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5066 38.5979C16.4783 36.5696 15.0035 34.0438 14.2197 31.2861C14.0967 30.8536 14.0014 30.5182 14 30.0583C13.9985 29.5327 14.1697 28.8742 14.4272 28.4159C14.8699 27.6277 15.8205 26.6177 16.6416 26.2024C17.3511 25.8435 18.1889 25.8435 18.8984 26.2024C19.5948 26.5546 20.3936 27.3699 20.8177 28.0222C21.3564 28.8508 21.3564 29.9191 20.8177 30.7477C20.6733 30.9697 20.4675 31.1751 20.2286 31.4136C20.1543 31.4879 20.0724 31.5415 20.1268 31.6548C20.6666 32.7792 21.4028 33.8338 22.3367 34.7677C23.2706 35.7016 24.3253 36.4379 25.4497 36.9777C25.5661 37.0336 25.6138 36.953 25.6909 36.8758C25.9293 36.637 26.1348 36.4312 26.3568 36.2868C27.1854 35.7481 28.2537 35.7481 29.0823 36.2868C29.7346 36.7109 30.5499 37.5097 30.9021 38.2061C31.261 38.9156 31.261 39.7534 30.9021 40.4628C30.4899 41.2778 29.4881 42.2282 28.6886 42.6773C28.2303 42.9348 27.5718 43.106 27.0462 43.1044C26.5862 43.1031 26.2509 43.0078 25.8183 42.8848C23.0607 42.1011 20.5348 40.6261 18.5066 38.5979Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3234_25437",
    x: 0.25,
    y: 9.88672,
    width: 50.7632,
    height: 50.7627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3234_25437"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3234_25437",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3234_25437",
    x: 14,
    y: 24.6377,
    width: 18.3917,
    height: 20.4668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3234_25437"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3234_25437",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3234_25437",
    x1: 1.5829,
    y1: 17.8849,
    x2: 36.9756,
    y2: 49.7221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6868FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3234_25437",
    x1: 40.1368,
    y1: 16.1736,
    x2: 6.53685,
    y2: 50.6578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBookCall);
export default __webpack_public_path__ + "static/media/ImgBookCall.4b8b3dd5225c68fd929419d9b8da0c3d.svg";
export { ForwardRef as ReactComponent };